export const LANGUAGES = {
  af: 'af',
  ar: 'ar',
  be: 'be',
  bg: 'bg',
  bs: 'bs',
  ca: 'ca',
  he: 'he',
  cs: 'cs',
  da: 'da',
  de: 'de',
  nl: 'nl',
  el: 'el',
  en: 'en_us',
  en_us: 'en_us',
  en_ca: 'en_ca',
  en_gb: 'en_gb',
  es: 'es',
  es_es: 'es_es',
  et: 'et',
  fi: 'fi',
  fil: 'fil',
  fr: 'fr',
  fr_ca: 'fr_ca',
  hi: 'hi',
  hr: 'hr',
  hu: 'hu',
  id: 'id',
  is: 'is',
  it: 'it',
  ja: 'ja',
  ka: 'ka',
  kk: 'kk',
  ko: 'ko',
  ky: 'ky',
  lt: 'lt',
  lv: 'lv',
  no: 'no',
  pa: 'pa',
  pl: 'pl',
  pt: 'pt',
  pt_br: 'pt_br',
  ro: 'ro',
  ru: 'ru',
  sk: 'sk',
  sl: 'sl',
  sq: 'sq',
  sr: 'sr',
  sr_me: 'sr_me',
  sv: 'sv',
  sw: 'sw',
  th: 'th',
  tr: 'tr',
  tw: 'tw',
  uk: 'uk',
  ur: 'ur',
  uz: 'uz',
  vi: 'vi',
  zh: 'zh_cn',
  zh_cn: 'zh_cn',
  zh_tw: 'zh_tw',
};
